import * as React from 'react';
import { IComparedWeight } from '../../../data/providers/reports/weightReportProvider';
import { Entity } from '../../../data/types';
import { Row } from '../../layout/Row';
import { ListAvatar } from '../../shared/List/ListAvatar';
import { Metric } from '../../shared/Metric';
import { TrafficLight } from '../../shared/TrafficLight';
import { EPdfMode, isPdf, shouldInvert } from '../../shared/pdf/Pdf';
import { DataCell, DataColumn } from '../utils/Table';

interface IProps {
  result: IComparedWeight;
  pdfMode: EPdfMode;
  entity: Entity;
  color: string;
  rank: number;
  shape: number[];
  lowerCutoff: number;
  upperCutoff: number;
}

export const WeightResult = (props: IProps): React.ReactElement => {
  return (
    <Row
      className='avoid-break'
      style={{
        height: '100%',
      }}
    >
      <DataColumn style={{ flex: props.shape[0] }}>
        <DataCell style={{ padding: 0 }}>
          <TrafficLight
            direction={-1}
            lowerCutoff={props.lowerCutoff}
            upperCutoff={props.upperCutoff}
            value={props.result.changePercentage}
            useAbsoluteValueInCutoff
          />
        </DataCell>
      </DataColumn>
      <DataColumn style={{ flex: props.shape[1], minWidth: 0 }}>
        <DataCell style={{ flex: 1, padding: '0px' }}>
          <ListAvatar
            entity={props.result.entity}
            inverse={shouldInvert(props.pdfMode)}
            pdf={isPdf(props.pdfMode)}
          />
        </DataCell>
      </DataColumn>
      <DataColumn style={{ flex: props.shape[2] }}>
        <DataCell style={{ flexDirection: 'column' }}>
          <div
            style={{ color: 'var(--color-secondary-text)', fontSize: '0.8em' }}
          >
            {props.result.targetTimeframe}
          </div>
          <Metric
            style={{ alignItems: 'center' }}
            value={props.result.targetMean}
            units={props.result.units}
          />
        </DataCell>
      </DataColumn>
      <DataColumn style={{ flex: props.shape[3] }}>
        <DataCell style={{ flexDirection: 'column' }}>
          <div
            style={{ color: 'var(--color-secondary-text)', fontSize: '0.8em' }}
          >
            {props.result.baselineTimeframe}
          </div>
          <Metric
            style={{ alignItems: 'center' }}
            value={props.result.baselineMean}
            units={props.result.units}
          />
        </DataCell>
      </DataColumn>
      <DataColumn style={{ flex: props.shape[4] }}>
        <DataCell>
          <Metric
            style={{ alignItems: 'center' }}
            value={props.result.change}
            units={props.result.units}
          />
        </DataCell>
      </DataColumn>
      <DataColumn style={{ flex: props.shape[5] }}>
        <DataCell lastInRow>
          <Metric
            style={{ alignItems: 'center' }}
            value={props.result.changePercentage}
            units='%'
          />
        </DataCell>
      </DataColumn>
    </Row>
  );
};
